import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import React, { useState, useLayoutEffect } from "react"
import moment from "moment"
import { TopSection } from "../TopSection"
import { DateInput } from "@carrotfertility/carotene"
import { FormProvider, useForm } from "react-hook-form"
import useSubmitWithErrorCatch from "../../../csd-enrollment/hooks/useSubmitWithErrorCatch"
import useAboutYou from "../hooks/useAboutYou"
import { useHistory } from "react-router"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import { FleLoading } from "../FleLoading"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"

const AboutYouDateOfBirth = ({ next, previous }) => {
  const history = useHistory()
  const formMethods = useForm()
  const { goBack, wentBack } = useAboutYouFlowControls()
  const { data, updateAboutYou, isFetching, continueLoading } = useAboutYou()
  const [dateOfBirthFilled, setDateOfBirthFilled] = useState(data?.dateOfBirth)

  useLayoutEffect(() => {
    if (!wentBack && data?.dateOfBirth) {
      history.push(next)
    }
  }, [data, history, wentBack, next])

  const { onSubmit } = useSubmitWithErrorCatch(async ({ dateOfBirth }) => {
    await updateAboutYou({ dateOfBirth })
    history.push(next)
  })

  return isFetching ? (
    <FleLoading />
  ) : (
    <FormProvider {...formMethods}>
      <FleLayout
        closeButton
        bottomContent={
          <FleContinueWrapper>
            <ContinueArrow
              onClick={formMethods.handleSubmit(onSubmit)}
              enabled={dateOfBirthFilled && !continueLoading}
            />
          </FleContinueWrapper>
        }
      >
        <AboutYouTopSection previous={previous}>
          <TopSection progressStep={2} leftOrBackArrow={<BackArrow onClick={() => goBack(previous)} />} />
        </AboutYouTopSection>
        <SwitchH2ToBodyLarge>When were you born?</SwitchH2ToBodyLarge>
        <Spacer height={1.5} />
        <DateInput
          error={Boolean(formMethods.errors["dateOfBirth"])}
          ref={formMethods.register({ required: "Required" })}
          defaultValue={moment(data?.dateOfBirth || "").format("YYYY-MM-DD")}
          name="dateOfBirth"
          label="Date of birth"
          onChange={(value) => {
            setDateOfBirthFilled(value)
          }}
        />
      </FleLayout>
    </FormProvider>
  )
}

export { AboutYouDateOfBirth }
